import 'leaflet/dist/leaflet.css'
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import L from 'leaflet'
import 'leaflet-draw';
import "leaflet.markercluster";
import element from 'element-ui';
import {
  addTag,
  delTag,
  editTag
} from '@/utils/map/mapapi';


var user_map = {
  mapID: null,
  markerIcon: function () {
    return L.icon({
      iconUrl: require("@/assets/img/marker-icon.png"),
      iconRetinaUrl: require("@/assets/img/marker-icon.png"),
      iconSize: [18, 29],
      //第一个参数为marker图标的x的一半，第二个必须是y的值，要不在地图上面会发生偏移
      iconAnchor: [9, 29], //弹出窗口的图标指示点相对于上面图标的左上角的位置这里居中故为25/2=12.5
      popupAnchor: [1, -20], //弹出窗口相对于marker的位置
      labelAnchor: [0, -5] //label里marker的距离

    })
  }
}

//绑定弹出框
function bindpophtml(id, title, des) {
  title = title ? "value=" + title : "";
  des = des ? des : ""
  var pophtml = '<form class="form-horizontal" style=" margin-top:22px" role="form"> ' +
    '<div class="form-group"><label style="padding:7px 5px 0px 5px" class="col-sm-2 control-label">标题:</label>' +
    '<div class="col-sm-10"> <input type="text" class="form-control" id="input_title" ' + title + '  placeholder="请输入标题!"></input></div></div>' +
    '<div class="col-sm-10"> <textarea class="form-control" id="input_des" placeholder="请输入描述！">' + des + '</textarea></div></div><div class="form-group">' +
    '<div class="col-sm-4"><a style="line-height:26px; cursor:pointer" onclick="dele_user_marker(\'' + id + '\')">删除标记</a></div><div class="col-sm-offset-2 col-sm-6">' +
    '<input type="button" style="background-color:#81AAE5;margin-right:15px" class="btn btn-default" value="确定" onclick="user_marker_sure(\'' + id + '\');" />' +
    '<input type="button" class="btn btn-default" value="取消" onclick="Cancel_marker(\'' + id + '\')" /></div></div></form>';
  return pophtml;
}

//初始化地图
const createMap = (divId, options) => {
  var left_point = L.latLng(90, -180),
    right_point = L.latLng(-90, 180),
    boundsMax = L.latLngBounds(left_point, right_point);
  options = {
    crs: L.CRS.EPSG3857,
    center: L.latLng(34.9, 106.821),
    zoom: 6,
    maxZoom: 18,
    continuousWorld: false,
    boxzoom: true,
    zoomControl: false, //默认显示控制器按钮
    scrollWheelZoom: true,
    dragging: true,
    attributionControl: false,
    measureControl: true,
    contextmenu: true,
    maxBounds: boundsMax
  };
  let map = L.map(divId, options)
  var editableLayers = new L.FeatureGroup();
  map.addLayer(editableLayers);
  //监听事件
  map.on(L.Draw.Event.CREATED, function (e) {
    
    var type = e.layerType,
      layer = e.layer;
    var point_position = e.layer.getLatLng();
    // if (type === 'marker') {
    //     layer.bindPopup('A popup!');
    // }

    if (type == 'marker') {
      var point_position = e.layer.getLatLng();
      // if (moringFlag == 'dept')
      //   savedeptMonitor(point_position);
      // else if (moringFlag = "usermarker") {
      saveUserMarker(map, point_position);
      // }
    }
    
  });

  return map
}


//添加创建地图的函数
const createTileLayer = (map, data) => {

  let tileLayer = L.layerGroup(data); //L.tileLayer(url, options)
  //tileLayer.addTo(map);
  var mapdiv = map.addLayer(tileLayer);
  console.log("tileLayer：" + tileLayer);
  return mapdiv;
}
//布点
const showDeptBD = (map, data) => {
  for (var i = 0; i < data.length; i++) {
    var obj = data[i];
    var r = /^(\+|-)?[0-9]+.?[0-9]*$/;
    if (!r.test(obj.Y) || !r.test(obj.X))
      continue;
    var point = L.point(obj.X, obj.Y);
    var marker = L.marker(L.latLng(point.x, point.y), {
      title: obj.Name
    });
    //marker.bindLabel("重庆市科学技术委员会",{noHide: true, offset: [18, -25] });
    marker.setIcon(new user_map.markerIcon); //更改标记图标
    var Fax = obj.Fax && obj.Fax != null ? obj.Fax : "";
    var Phone = obj.Phone && obj.Phone != null ? obj.Phone : "";
    var pophtml = '<div>';
    pophtml += '<ul>';
    pophtml += '<li><span style="font-size:16px;font-weight:bold">' + obj.Name + '</span></li>';
    pophtml += '<hr style="margin:10px 0px;"></hr>';
    pophtml += '</ul>';
    pophtml += '</div>';
    pophtml += '<div style="display: block;">';
    pophtml += '<table style="font-size:14px">';
    pophtml += '<tr><td><lable style="font-weight:bold">名称：</lable>' + obj.Name + '</td></tr>';
    pophtml += '<tr><td><lable style="font-weight:bold">地址：</lable>' + obj.Address + '</td></tr>';
    pophtml += '<tr><td><lable style="font-weight:bold">传真：</lable>' + Fax + '</td></tr>';
    pophtml += '<tr><td><lable style="font-weight:bold">电话：</lable>' + Phone + '</td></tr>';
    pophtml += '<tr><td><lable style="font-weight:bold">所属省份：</lable>' + obj.Province + '</td></tr>';
    pophtml += '<tr><td><lable style="font-weight:bold">所属地区：</lable>' + obj.Area + '</td></tr>';
    pophtml += '<tr><td><lable style="font-weight:bold">类型：</lable>' + obj.Type + '</td></tr>';
    pophtml += '</table></div>';
    marker.bindPopup(pophtml, {
      minWidth: 280
    });
    marker.sysId = obj.ID;
    var mapmarker = map.addLayer(marker);
    // marker.openPopup();
  }
}
//点击添加地标事件
const AddMarker = (map) => {
  var addmarker = new L.Draw.Marker(map);
  addmarker._initialLabelText = "点击添加标签";
  addmarker.options.icon = new user_map.markerIcon;
  addmarker._enabled = true;
  addmarker.addHooks();
  //return addmarker;
}
//取消添加框
const Clancemap = (map, mid) => {
  map._makerClusterGroup.eachLayer(function (l) {
    if (l.sysId && l.sysId === mid) {
      l.closePopup();
    }
  });
}

const reloadMarkerCluster = (map) => {
  if (map._makerClusterGroup == undefined) {
    map._makerClusterGroup = L.markerClusterGroup({
      spiderfyDistanceMultiplier: 3,
      maxClusterRadius: 38,
      disableClusteringAtZoom: 13
    }).addTo(map);
  }
}

const userMarkerSure=(map,obj)=>{
 
  editTag(obj).then((res)=>{
    debugger;
    if(res.Code==200)
    {
      element.MessageBox({
        type: "success",
        message: res.Message,
        position: "bottom-right",
      });
      map._makerClusterGroup.eachLayer(function (l) {
        if (l.sysId && l.sysId === obj.ID) {
            l.closePopup();
            var tips = obj.Title;
            l.bindTooltip(tips, { permanent: true, direction: 'right'});//小气泡 给标注加名字
          
            var content = bindpophtml(obj.ID, obj.Title, obj.Description);
            l.setPopupContent(content);
        }
    });
    }
  });
}

//删除标注
const deluserMarker=(map,obj)=>{
 
  delTag({"ID":obj}).then((res)=>{
    debugger;
    if(res.Code==200)
    {
      
      map._makerClusterGroup.eachLayer(function (l) {
        if (l.sysId && l.sysId === mid) {
          map._makerClusterGroup.removeLayer(l);
          map.removeLayer(l);
          element.MessageBox({
            type: "success",
            message: res.Message,
            position: "bottom-right",
          });
      }
      });
    }
  });
}


//打开地图地标
const OpenUserMap = (map, data, obj) => {

  ClearMarker(map);
  user_map.mapID = obj.ID;
  reloadMarkerCluster(map);
  var zoom = obj.Zoom ? obj.Zoom : map.getZoom();
 
  var strcenter = obj.Polygon_Point== "new L.Polygon([])" ?map.getCenter():eval(obj.Polygon_Point).getBounds().getCenter();
  var center = L.latLng(strcenter.lat, strcenter.lng);
  map.setView(center, zoom);
  
  for (var i = 0; i < data.length; i++) {
    var value = data[i];
    var marker = L.marker(L.latLng(value.X, value.Y), {
      title: value.Title
    });
     debugger;
     marker.bindTooltip(value.Title, { permanent: true, direction: 'right'});//小气泡 给标注加名字
    marker.setIcon(new user_map.markerIcon);
    marker.bindPopup(value.Title, {
      minWidth: 280
    });
    
    marker.sysId = value.ID;
    map._makerClusterGroup.addLayer(marker)
    var pophtml = bindpophtml(value.ID, value.Title, value.Description);
    marker.setPopupContent(pophtml);
  }
}
//清除图层
const ClearMarker = (map) => {
  if (map._makerClusterGroup !== undefined) {
    map.removeLayer(map._makerClusterGroup);
    map._makerClusterGroup.eachLayer(function (l) {
      map.removeLayer(l);
    });
    map._makerClusterGroup.clearLayers();
    delete map._makerClusterGroup;
    map._makerClusterGroup = null;
  }
}

//保存更新坐标信息
const saveUserMarker = (map, data_a) => {
  reloadMarkerCluster(map);
  
  element.MessageBox.confirm("你确定添加标注吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(() => {
      
      var zoom=+ map.getZoom();
      var tagform = {
        MapID:user_map.mapID,
        Title:"",
        Description :"",
        X:data_a.lat,
        Y: data_a.lng,
        Zoom:zoom,
      }
      addTag(tagform).then((res) => {
        var title="";
        if (res.Code == 200) {
          var data = res.Data;
          // map_para.markerID = data;
          var marker = L.marker(L.latLng(data_a.lat, data_a.lng), {
            title: title
          });
          // marker.bindLabel(title, {
          //   noHide: true,
          //   offset: [18, -25]
          // });
          marker.setIcon(new user_map.markerIcon);
          marker.bindPopup("", {
            minWidth: 280
          });
          marker.sysId = data;
          map._makerClusterGroup.addLayer(marker).addTo(map);
          // _id = marker._leaflet_id;
          var pophtml = bindpophtml(data);
          marker.setPopupContent(pophtml);
          marker.openPopup();
        }
      });
    })
    .catch(() => {
      element.MessageBox({
        type: "info",
        message: "已取消删除",
        position: "bottom-right",
      });
    });

}


export default {
  createMap,
  createTileLayer,
  showDeptBD,
  AddMarker,
  ClearMarker,
  OpenUserMap,
  Clancemap,
  userMarkerSure,
  deluserMarker
}


// WEBPACK FOOTER //
// ./src/utils/map/map.js